module.exports = __webpack_public_path__ + "static/media/download-qr.7b405215.png";